import React from 'react'
import { useFilterStore } from '../../state/filterStore'
import { mapStore } from '../../state/mapStore'

const BreweriesCountTitle: React.FC = () => {
    // Map Store
    const locations = mapStore((state) => state.locations)
    const activeTab = mapStore((state) => state.activeTab)
    const currentLocation = mapStore((state) => state.currentLocation)
    const selectedWildcardOption = mapStore((state) => state.selectedWildcardOption)

    // Filter Store
    const stateFilter = useFilterStore((state) => state.stateFilter)

    const showNearbyTitle =
        selectedWildcardOption?.type === 'place' &&
        selectedWildcardOption?.label !== 'Current map area'
    return stateFilter.label !== 'All' ? (
        <p className='font-base mb-4 pl-4'>
            <span className='mr-1 font-bold'>{locations?.length || 0}</span>
            breweries in <span className='font-bold'>{stateFilter.label}</span>
        </p>
    ) : (
        <p className='font-base mb-4 pl-4'>
            <span className='mr-1 text-lg font-bold'>{locations?.length || 0}</span>
            <span className='text-lg'>Breweries</span>
            {activeTab !== 'routes' ? (
                showNearbyTitle && <span className='text-lg'>{` near ${currentLocation}`}</span>
            ) : (
                <span className='font-bold'> near your route</span>
            )}
        </p>
    )
}
export { BreweriesCountTitle }
